import dayjs from 'dayjs';
import moment from 'moment-timezone';

import { FormatDateType } from './interfaces';
import { TIME_ZONE_ABBREVIATIONS } from '../constants/timezones';

const TIME_FORMAT = 'hh:mm A';
const DATE_FORMAT = 'MMM DD, YYYY';

export const formatTime: FormatDateType = (date) =>
  dayjs(date).format(TIME_FORMAT);

export const formatDate: FormatDateType = (date) =>
  dayjs(date).format(DATE_FORMAT);

export const getESTDate = (date = new Date()): Date => {
  const estDate = new Date(
    date.toLocaleString('en-US', { timeZone: 'America/New_York' }),
  );

  return estDate;
};

export const convertToDate = (unixTimestamp: number): Date => {
  return new Date(unixTimestamp * 1000);
};

export const generateTimeZoneAbbr = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let timeZoneAbbr = moment.tz(timeZone).format('z');

  if (!['+', '-'].includes(timeZoneAbbr[0])) {
    return timeZoneAbbr;
  }

  timeZoneAbbr = TIME_ZONE_ABBREVIATIONS[timeZone];

  if (timeZoneAbbr) {
    return timeZoneAbbr;
  }

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short',
  });

  const parts = formatter.formatToParts(new Date());
  const timeZonePart = parts.find((part) => part.type === 'timeZoneName');

  return timeZonePart ? timeZonePart.value : '';
};

export const getTimeFormat = (date: Date): string => {
  return dayjs(date)
    .format('h:mm a')
    .toLowerCase()
    .replace('am', 'a.m.')
    .replace('pm', 'p.m.');
};

export const getDifferenceInMinutes = (unixTimestamp: number) => {
  return dayjs(convertToDate(unixTimestamp)).diff(new Date(), 'm');
};
